import { useCallback, useEffect, useState } from "react";
import { Completed } from "../components/Completed";
import { DrillResult } from "../components/DrillResult";
import { drillCompleted } from "../assessmentSequence";
import { startMinefield } from "../controllers/minefield";
import { isB2BUserSession } from "../globalState";

// cookie just needs to be different every time, so that the effect will run once each invocation
const DrillMinefield = ({ cookie, retake }) => {

	const [result, setResult] = useState();
	const [nextStep, setNextStep] = useState();
	const [todo, setTodo] = useState();

	const minefieldCompleted = useCallback((transcript) => {
		document.getElementById('root').ontouchstart = function () { };

		drillCompleted("minefield", retake, transcript.stringify())
			.then(({ nextStep, result, todo }) => {
				setResult(result);
				setNextStep(nextStep);
				setTodo(todo);
			});
	}, [retake]);

	useEffect(() => {
		document.getElementById('root').ontouchstart = function (e) { e.preventDefault(); };

		startMinefield(minefieldCompleted);
	}, [cookie, minefieldCompleted]);

	if (result) {
		return <DrillResult drill="minefield" result={result} />
	}

	if (nextStep) {
		return <Completed current="minefield" next={nextStep} todo={todo} />;
	}


	// XXX - HACK for ai.io AWS conference - remove reflexion logo
	if (isB2BUserSession)
		return (
			<div id="minefield-background">
				<div id="screen"></div>
			</div>
		)
	// XXX - HACK for ai.io AWS conference - remove reflexion logo


	// the drill itself
	return (
		<div id="minefield-background">
			<div id="screen" class="has-rfxn-logo"></div>
		</div>
	)
};

export default DrillMinefield;
